//
//
//
//
//
//
//
//
//
//
//
//

  import moment from 'dayjs';

  export default {
    name: 'clocker',
    props: {
      nowTime: {
        type: String,
        required: true
      },
      endTime: {
        type: String,
        required: true
      },
      style: String,
      textStyle: String,
      colonStyle: String,
      onPrevEnd: Function,
      onEnd: Function,
      onChange: Function
    },
    create() {
      this.start();
    },
//    beforeUpdate() {
//      if (this.nowTime !== nextProps.nowTime) {
//        this.reStart();
//      } else if(this.endTime !== nextProps.endTime) {
//        console.log('~~~~~~~~~ 切换了endTime ~~~~~~', this.endTime, nextProps.endTime)
//        this._endTime = moment(Number(nextProps.endTime) * 1000);
//      }
//    },
    beforeDestroy() {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
    },
    watch: {
      endTime(newEndTime, oldEndTime) {
        if (oldEndTime !== newEndTime) {
          console.log('~~~~~~~~~ 切换了endTime ~~~~~~', oldEndTime, newEndTime);
          this._endTime = moment(Number(newEndTime) * 1000);
        }
      },
      nowTime(newNowTime, oldNowTime) {
        if (oldNowTime !== newNowTime) {
          this.reStart();
        }
      }
    },
    methods: {
      start() {
        console.log('nowTime =========>', this.nowTime);
        console.log('endTime =========>', this.endTime);

        if (!this.endTime && !this.nowTime) return;
        this._nowTime = moment(Number(this.nowTime) * 1000);
        this._endTime = moment(Number(this.endTime) * 1000);

        console.log('nowTime=========>', this._nowTime.format('YYYY-MM-DD HH:mm:ss'));
        console.log('endTime=========>', this._endTime.format('YYYY-MM-DD HH:mm:ss'));
        this.update();
        this.interval = setInterval(() => {
          this.update();
        }, 1000);
      },

      reStart() {
        if (this.interval !== null) {
          clearInterval(this.interval);
        }
        this.start();
      },

      checkTime(i) {
        if (i < 10) {
          i = '0' + i;
        }
        return i;
      },

      updateEndTime(endTime) {
        this._endTime = moment(Number(endTime) * 1000);
      },

      update() {
        const nowTime = this._nowTime.add(1, 'second').toDate();
        const endTime = this._endTime.toDate();
        console.log('nowTime', moment(nowTime).format('YYYY-MM-DD HH:mm:ss'));
        console.log('endTime', moment(endTime).format('YYYY-MM-DD HH:mm:ss'));

        let totalSecs = endTime.getTime() - nowTime.getTime();
        totalSecs = Math.ceil(totalSecs / 1000);
        totalSecs = totalSecs < 0 ? 0 : totalSecs;

        const fmt = {
          seconds: this.checkTime(totalSecs % 60),
          minutes: this.checkTime(Math.floor(totalSecs / 60) % 60),
          hours: this.checkTime(Math.floor(totalSecs / 60 / 60))
        };

        console.log('fmt', fmt);
        this.emit('onChange', fmt, nowTime);

        if (totalSecs == 1) {
          this.emit('onPrevEnd', endTime, nowTime);
          setTimeout(() => {
            this.emit('onEnd', endTime, nowTime);
          }, 1000);
        }

        this.fmt = fmt;
      }
    },
    data() {
      return {
        endTime: undefined,
        interval: null,
        fmt: ''
      };
    },
    beforeDestroy() {
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
    }
  };



// WEBPACK FOOTER //
// ./src/components/Clocker.vue